import { get } from "../../service/api";

const GetVatMerchants = async (merchantId) => {
    try {
        const response = await get(`/merchant/${merchantId}/vatMerchantDropdown`);
        return response.data;
    } catch (error) {
        console.error('Error getVatMerchants:', error);
        throw error;
    }
};

export default GetVatMerchants;